import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {
  private promise: Promise<void> | null = null;

  load(): Promise<void> {
    // If already loading/loaded, return the existing promise (Singleton pattern)
    if (this.promise) {
      return this.promise;
    }

    // Create a new promise to load the script
    this.promise = new Promise((resolve, reject) => {
      // Check if google maps is already available on window
      if ((window as any).google && (window as any).google.maps) {
        resolve();
        return;
      }

      // Create the global callback that Google will execute
      const callbackName = 'googleMapsCallback';
      (window as any)[callbackName] = () => {
        resolve();
      };

      // Inject the script tag
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.google.googleMapsKey}&libraries=places&loading=async&v=weekly&callback=${callbackName}`;
      script.async = true;
      script.defer = true;

      script.onerror = (error) => reject(error);

      document.head.appendChild(script);
    });

    return this.promise;
  }
}
